(() => {
  const viewer = document.querySelector('[data-norea-image-viewer]');
  if (!viewer || typeof viewer.showModal !== 'function') return;
  const image = viewer.querySelector('[data-norea-viewer-image]');
  const zoom = viewer.querySelector('[data-norea-image-zoom]');
  const stage = viewer.querySelector('.norea-image-viewer__stage');
  if (!image || !zoom || !stage) return;
  let trigger;
  const reset = () => {
    zoom.setAttribute('aria-pressed', 'false');
    viewer.removeAttribute('data-zoomed');
    stage.scrollTop = 0;
    stage.scrollLeft = 0;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-norea-full-image]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let url;
    try { url = new URL(link.href, document.baseURI); } catch { return; }
    if (!['http:', 'https:'].includes(url.protocol)) return;
    const source = link.querySelector('img');
    if (!source) return;
    reset();
    image.alt = source.alt;
    image.width = source.naturalWidth || source.width || 2048;
    image.height = source.naturalHeight || source.height || 2048;
    image.src = url.href;
    try { viewer.showModal(); } catch { return; }
    trigger = link;
    event.preventDefault();
  });
  zoom.addEventListener('click', () => {
    const expanded = zoom.getAttribute('aria-pressed') !== 'true';
    zoom.setAttribute('aria-pressed', String(expanded));
    viewer.toggleAttribute('data-zoomed', expanded);
    if (!expanded) { stage.scrollTop = 0; stage.scrollLeft = 0; }
  });
  viewer.addEventListener('close', () => {
    reset();
    image.removeAttribute('src');
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    trigger = null;
  });
})();
